import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextSnippetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_snippet"}/>
}
